(function (window, document, undefined) {
  "use strict";

  const showPaidSectionLabel = () => {
    const paidSectionLabel = document.querySelector(".vodl-paid-section-label");
    if (paidSectionLabel) {
      paidSectionLabel.style.display = "flex";
    }
  };

  const init = () => {
    document.addEventListener("vodl_show_full_content", showPaidSectionLabel);
  };

  init();
})(window, document);
